import { computed } from "vue";
import { currentTheme, setTheme } from "@/theme";

let appMap = {
  tg_green: "臻甜瓜分期",
  tg_blue: "臻甜瓜",
};
export function useTheme() {
  return {
    currentTheme: computed(() => currentTheme.value),
    setTheme,
    appName: computed(() => appMap[currentTheme.value] || "臻甜瓜分期"),
  };
}
